module.exports = __webpack_public_path__ + "img/about_001.6db0d51.png";